import { defineMobileFormWindow } from "@app/overlay";
import { BalanceDocType } from "@src/types/business/balanceDocType";
import { WsInplantInsertForm, type WsInplantInsertFormProps } from "./components/WsInplantsInsert/WsInplantInsertForm";
import { WsInplantsFilterForm, type WsInplantsFilterFormProps } from "./components/WsInplantsFilter/WsInplantsFilterForm";

/** Реестр overlay-окон списка ВЗН УП. */
export const wsInplantsListWindows = {
    filter: defineMobileFormWindow<WsInplantsFilterFormProps>({
        key: "workshop.inplants.filter",
        title: ({ listType }) => `Фильтр ВЗН УП (${listType === BalanceDocType.Arrival ? "Приход" : "Расход"})`,
        ownerLifecycle: "detached",
        component: WsInplantsFilterForm,
    }),
    create: defineMobileFormWindow<WsInplantInsertFormProps>({
        key: "workshop.inplants.create",
        title: "Создание ВЗН (Расход)",
        trackUnsavedFormChanges: true,
        component: WsInplantInsertForm,
    }),
};
